import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhxDatePickerGroupComponent } from './phx-date-picker-group.component';
import { PhxDropdownModule } from '../dropdown/phx-dropdown.module';
import { PhxMenuModule } from '../menu/menu.module';
import { PhxAddonModule } from '../addon/phx-addon.module';
import { FormsModule } from '@angular/forms';
import { A11yModule } from '@angular/cdk/a11y';

@NgModule({
  declarations: [PhxDatePickerGroupComponent],
  imports: [
    CommonModule,
    FormsModule,
    A11yModule,
    PhxAddonModule,
    PhxDropdownModule,
    PhxMenuModule,
  ],
  exports: [PhxDatePickerGroupComponent],
})
export class PhxDatePickerGroupModule { }
